/**
 * @file Helpers for managing client-side state related to kiosk mode.
 */

import { getQueryParam } from "../browser/queryParams";

/**
 * Return the current URL's query string with the "kiosk" parameter removed.
 *
 * @returns {string} The current URL as a string with the "kiosk" parameter removed.
 */
export const getUrlWithoutKioskParameter = () => {
  const url = window.location.href;
  const urlObj = new URL(url);
  urlObj.searchParams.delete("kiosk");
  return urlObj.toString();
};

/**
 * Determines if the app is running in kiosk mode.
 *
 * @returns {boolean} `true` if the "kiosk" URL parameter is set to "true", otherwise `false`.
 */
export const getIsKioskMode = () => {
  return getQueryParam("kiosk") === "true";
};
